import ContactItem from '../../../../components/common/contact/ContactItem';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';
import { IContactSectionEntry } from '../../../../contentful/types/IContactSectionEntry';
import { Section, SectionHeader } from './Section';
import { IAirlineSectionEntry } from '../../../../contentful/types/IAirlineSection';
import CardsContainer from '../../../../components/common/cards/CardsContainer';
import { getValidExternalUrl } from '../../../../utils/getValidExternalUrl';
import { getContactImageSource } from '../../../../utils/getContactImageSource';
import { getLinkHref } from '../../../../utils/getLinkHref';

interface IContactSectionProps {
	id: string;
	section: IContactSectionEntry | IAirlineSectionEntry;
}

export default function ContactSection({ id, section }: IContactSectionProps) {
	return (
		<Section id={id}>
			{section.fields.title && (
				<SectionHeader styling="h4">{section.fields.title}</SectionHeader>
			)}
			<CardsContainer>
				{section.fields.items?.map((item, index) =>
					item.contentType === 'contact-item' ? (
						<ContactItem
							key={getListedEntryKey(item, index)}
							title={item.fields.title}
							subtitle={item.fields.subtitle}
							imageSource={getContactImageSource(
								item.fields.image,
								section.fields.imageOrientation ?? 'Landscape',
							)}
							linkTitle={item.fields.websiteTitle}
							imageAlt={item.fields.image?.fields.description}
							type={
								section.contentType === 'airline-section'
									? 'airline'
									: 'contact'
							}
							isPortrait={section.fields.imageOrientation === 'Portrait'}
							body={item.fields.body}
							links={{
								phoneNumber: item.fields.phoneNumber,
								email: item.fields.email,
								externalLink: getLinkHref(item.fields.website),
								internalLink: item.fields.internalLink,
							}}
						/>
					) : (
						<ContactItem
							key={getListedEntryKey(item, index)}
							title={item.fields.name}
							subtitle={item.fields.subtitle}
							imageSource={getContactImageSource(
								item.fields.logo,
								section.fields.imageOrientation ?? 'Landscape',
							)}
							linkTitle={item.fields.description}
							imageAlt={item.fields.logo?.fields.description}
							type={
								section.contentType === 'airline-section'
									? 'airline'
									: 'contact'
							}
							links={{
								phoneNumber: item.fields.phoneNumber,
								externalLink:
									(item.fields.website &&
										getValidExternalUrl(item.fields.website)) ||
									'',
							}}
						/>
					),
				)}
			</CardsContainer>
		</Section>
	);
}
